<div *ngIf="pageLoading1 || pageLoading2" class="loader text-center">
	<img src="../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.User_Master=='Full') {
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-9">
			<div class="row mb-3">
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('first_name')}" id="first_name"
							formControlName="first_name" placeholder="">
						<label for="first_name">First Name*</label>
					</div>
					<p *ngIf="showError('first_name')" class="text-danger">
						<span *ngIf="f.first_name.errors?.required">
							Required
						</span>
						<span *ngIf="f.first_name.errors?.incorrect">
							{{customError.first_name}}
						</span>
					</p>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('last_name')}" id="last_name"
							formControlName="last_name" placeholder="">
						<label for="last_name">Last Name*</label>
					</div>
					<p *ngIf="showError('last_name')" class="text-danger">
						<span *ngIf="f.last_name.errors?.required">
							Required
						</span>
						<span *ngIf="f.last_name.errors?.incorrect">
							{{customError.last_name}}
						</span>
					</p>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
							formControlName="email" placeholder="">
						<label for="email">Email-Id*</label>
					</div>
					<p *ngIf="showError('email')" class="text-danger">
						<span *ngIf="f.email.errors?.required">
							Required
						</span>
						<span *ngIf="f.email.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.email.errors?.incorrect">
							{{customError.email}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col">
					<label>Email Signature:</label>
					<quill-editor id="email_signature" formControlName="email_signature" [modules]="quillConfig"
						[placeholder]="'Email Signature'"></quill-editor>
					<p *ngIf="showError('email_signature')" class="text-danger">
						<span *ngIf="f.email_signature.errors?.required">
							Required
						</span>
					</p>
				</div>
			</div>
		</div>
		<div class="col-3">
			<div class="row mb-3">
				<div class="col">
					<p class="text-center">
						<strong>Drop signature here</strong>
					</p>
					<app-file-upload [allowedFiles]="allowedLogoFiles" [uploadFolder]="'user_sign'"
						(uploaded)="stampUploaded($event)" [flag]="true">
					</app-file-upload>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col">
					@if (f.sign.value) {
					<img src="{{File_Storage_URL}}{{f.sign.value}}" class="sign" />
					}
				</div>
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th style="width: 30%;">Module</th>
						<th style="width: 70%;">Access<span class="text-danger">*</span></th>
					</tr>
				</thead>
				<tbody>
					<tr formArrayName="line_items" *ngFor="let creds of get_rows.controls; let i = index">
						<ng-container [formGroupName]="i">
							<td>
								{{creds.get('name')?.value}}
							</td>
							<td>
								<mat-radio-group formControlName="access">
									<mat-radio-button [value]="'Full'" [color]="'primary'">
										Full
									</mat-radio-button>
									<mat-radio-button [value]="'Readonly'" [color]="'primary'">
										Readonly
									</mat-radio-button>
									<mat-radio-button [value]="'NoAccess'" [color]="'primary'">
										No Access
									</mat-radio-button>
								</mat-radio-group>
								<p *ngIf="showError2(i,'access')" class="text-danger">
									<span *ngIf="creds.get('access')?.errors?.required">
										Required
									</span>
								</p>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}